import { call, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import { callApi, callApiWithNoAuth } from '../../api/Api';
import { stopLoading, showErrorMessage, startLoading } from '../layout/action';
import {
  START_EXTERNAL_CITATION_PAYMENT,
  GET_DRIVER_CITATION_STATES,
  GET_DRIVER_CREDIT_CARD_VALUE,
  GET_CITATION_PAYMENT_SETTINGS,
  GET_CITATION_PAYMENT_SETTINGS_WITHOUT_SESSION,
  setDriverCitationStates,
  setDriverCreditCardValue,
  setCitationPaymentSettings
} from './action';
import { RouteService, resolveCustomerName } from 'services/route.service';

export function* callGetDriverCitationStates(action) {
  try {
     const { loginState } = yield select();
     const { userContext } = loginState;
     yield put(startLoading())
     const stateResponse = yield call(callApi, {
        method: "GET",
        url: `/citations/account/${action.payload}`
     })
     const { data } = stateResponse;
     yield put(setDriverCitationStates(data))
     yield put(stopLoading())
  } catch (err) {
     yield put(stopLoading())
     yield put(showErrorMessage({ error: err, title: "Get Profile Data" }))
  }
}

export function* watchGetDriverCitationStates() {
  yield takeEvery(GET_DRIVER_CITATION_STATES, callGetDriverCitationStates);
}

export function* callGetDriverCreditCardValue(action) {
   try {
      const { loginState } = yield select();
      const { userContext } = loginState;
      yield put(startLoading())
      const stateResponse = yield call(callApiWithNoAuth, {
         method: "GET",
         // url: `/accepted-payment-methods/portal-citations/${action.payload}`
         url: `/portal/pages/home-without-session/accepted-payment-methods/portal-citations/${action.payload}`
      })
      const { data } = stateResponse;
      yield put(setDriverCreditCardValue(data))
      yield put(stopLoading())
   } catch (err) {
      yield put(stopLoading())
      yield put(showErrorMessage({ error: err, title: "Get Profile Data" }))
   }
 }
 
 export function* watchGetDriverCreditCardValue() {
   yield takeEvery(GET_DRIVER_CREDIT_CARD_VALUE, callGetDriverCreditCardValue);
 }

export function* callGetCitationPaymentSettings(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      url: `/citation/payment-settings/${action.payload}`
    })
    const { data } = stateResponse;
    yield put(setCitationPaymentSettings(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get Citation Payment Settings" }));
  }
}

export function* watchGetCitationPaymentSettings() {
  yield takeEvery(GET_CITATION_PAYMENT_SETTINGS, callGetCitationPaymentSettings);
}

export function* callGetCitationPaymentSettingsWithoutSession(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      url: `/portal/pages/home-without-session/citation-payment-settings/${action.payload}`
    })
    const { data } = stateResponse;
    yield put(setCitationPaymentSettings(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get Citation Payment Settings" }));
  }
}

export function* watchGetCitationPaymentSettingsWithoutSession() {
  yield takeEvery(GET_CITATION_PAYMENT_SETTINGS_WITHOUT_SESSION, callGetCitationPaymentSettingsWithoutSession);
}

function* externalCitationPaymentSaga(action) {
  try {
    yield put(startLoading());
    const store = yield select();
    const customerName = resolveCustomerName(
      store.homeState?.customerName,
      window.location.pathname
    );
    if (!customerName) {
      yield put(
        showErrorMessage({
          error: { data: { errorMessages: "Missing customer/realm context. Please reload the page." } },
          title: "External Citation Payment",
        })
      );
      return;
    }
    const { citationId } = action.payload;

    const response = yield call(callApiWithNoAuth, {
      method: 'GET',
      url: `/portal/pages/home-without-session/citations/${citationId}/external-payment`
    });

    const { url, parameters } = response.data;

    const confirmationUrl = RouteService.citationPaymentStatus(customerName)

    // Add signOutUrls parameter
    const fullParameters = {
      ...parameters,
      signOutUrl: `${process.env.REACT_APP_PORTAL_HOST}${confirmationUrl}`,
      incompleteSignOutUrl: `${process.env.REACT_APP_PORTAL_HOST}${RouteService.incompletePayment(customerName)}`,
    };

    // Add notification url
    if (fullParameters.alt_otpsso_url) {
      fullParameters.alt_otpsso_url = `${process.env.REACT_APP_PROXY_HOST}${fullParameters.alt_otpsso_url}`;
    }

    // Build query string
    const searchParams = new URLSearchParams();
    Object.keys(fullParameters).forEach(key => {
      searchParams.append(key, fullParameters[key]);
    });

    // Redirect to the external link
    window.location.href = `${url}?${searchParams.toString()}`;
  } catch (error) {
    yield put(showErrorMessage({ error: error, title: "External Citation Payment" }))
  } finally {
    yield put(stopLoading());
  }
}

export function* watchExternalCitationPaymentSaga() {
  yield takeLatest(START_EXTERNAL_CITATION_PAYMENT, externalCitationPaymentSaga);
}